import React from 'react'
import { Link, matchPath, useLocation } from 'react-router-dom'
import { Breadcrumb, BreadcrumbItem } from 'reactstrap'
import routes from '../../routes'
import {
    buildBreadcrumbPaths,
    buildServiceBreadcrumbs,
    TBreadcrumbItem,
} from '../../helpers/services/breadcrumbs'

const findRouteName = (url: string): string | undefined => routes[url]

type TProps = Record<string, never>

const renderBreadcrumbItem = (item: TBreadcrumbItem, key: string | number) =>
    item.active || !item.path ? (
        <BreadcrumbItem key={key} active={Boolean(item.active)}>
            {item.label}
        </BreadcrumbItem>
    ) : (
        <BreadcrumbItem key={key}>
            <Link to={item.path}>{item.label}</Link>
        </BreadcrumbItem>
    )

const renderStaticBreadcrumbItem = (path: string, pathname: string) => {
    const routeName = findRouteName(path)
    if (!routeName) {
        return null
    }

    const isActive = Boolean(matchPath(path, pathname))
    return renderBreadcrumbItem(
        {
            label: routeName,
            ...(isActive ? { active: true } : { path }),
        },
        path
    )
}

const Breadcrumbs: React.FC<TProps> = () => {
    const location = useLocation()
    const dynamicBreadcrumbs = buildServiceBreadcrumbs(
        location.pathname,
        location.state as { from?: string } | null
    )

    if (dynamicBreadcrumbs) {
        return (
            <Breadcrumb>
                {dynamicBreadcrumbs.map((item, index) =>
                    renderBreadcrumbItem(item, index))}
            </Breadcrumb>
        )
    }

    return (
        <Breadcrumb>
            {buildBreadcrumbPaths(location.pathname).map((path) =>
                renderStaticBreadcrumbItem(path, location.pathname))}
        </Breadcrumb>
    )
}

export default Breadcrumbs
